module.exports = __webpack_public_path__ + "media/images/icons/material/rocket-1864d608569b8886afab03c509264d7a.svg";